import { TFunction } from "i18next";

import { Badge, Text } from "@pentabd/ui";

import { ProfileInfoCard, ViewButton } from "@components";

import { ROUTES } from "@constants/routes";

import { useUser } from "@hooks/useUser";

import { getAccess } from "@helpers/permissionController";

import { AcrType } from "@type/HRM/acrs";
import { TABS } from "@constants/tab-serial";

const {
  HRM: { EMPLOYEES },
} = ROUTES;

export const TableColumn = (t: TFunction<"translation", undefined>) => {
  const { user } = useUser();
  const { realm_roles: roles } = user || {};

  return [
    {
      id: 1,
      name: t("ACR_LIST.TABLE.COLUMN.NAME"),
      key: "nameBn",
      render: (__: any, row: AcrType) => (
        <ProfileInfoCard employee={row.employee} />
      ),
    },
    {
      id: 2,
      key: "joiningDate",
      name: t("ACR_LIST.TABLE.COLUMN.JOINING_DATE"),
      render: (joiningDate: string) => (
        <Text color="subtitle2" className="text-nowrap">
          {joiningDate ? joiningDate.split("T")[0] : "..."}
        </Text>
      ),
    },
    {
      id: 3,
      key: "lastAcrDate",
      name: t("ACR_LIST.TABLE.COLUMN.LAST_ACR_DATE"),
      render: (lastAcrDate: string) => (
        <Text color="subtitle2" className="text-nowrap">
          {lastAcrDate ? lastAcrDate.split("T")[0] : "..."}
        </Text>
      ),
    },
    {
      id: 4,
      key: "status",
      name: t("ACR_LIST.TABLE.COLUMN.STATUS"),
      render: (status: boolean) => {
        return status ? (
          <Badge
            label="Provide ACR"
            type="danger"
            className="text-nowrap w-max"
          />
        ) : (
          <Badge
            label="No Pending ACR"
            type="success"
            className="text-nowrap w-max"
          />
        );
      },
    },
    {
      ...(getAccess(roles, "ACR_UPDATE_PAGE") && {
        id: 5,
        key: "view",
        render: (__: number, row: AcrType) => (
          <ViewButton link={`${EMPLOYEES}/${row.employeeId}?tab=${TABS.ACR}`} />
        ),
      }),
    },
  ];
};
